/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VcdsComponentIdAndType { 
    /**
     * Component Id
     */
    component_id?: string;
    /**
     * Component Type
     */
    component_type?: string;
}

